export const MAX_CHARS_PER_TEXT = 160
export const ACTIVE_CHILD_CAMPAIGN_TYPE_NAME = "ui_form_active_action"
export const MAX_CHARS_EXCEEDED_ERROR = `Message must not exceed ${MAX_CHARS_PER_TEXT} characters.`
export const KEYWORD_REGEX_VALIDATION_ERROR = "Sorry, this input is invalid."
export const CONFIRMATION_EMAIL_TEMPLATE_REQUIRED_ERROR = "Confirmation email template is a required field"
export const CONFIRMATION_EMAIL_SUBJECT_REQUIRED_ERROR = "Confirmation email subject is a required field"
export const CONFIRMATION_EMAIL_FROM_NAME_REQUIRED_ERROR = "From is a required field"
export const CONFIRMATION_EMAIL_FROM_ADDRESS_NO_AT_SIGN_ERROR = "Email address must not include a @"
export const CONFIRMATION_EMAIL_FROM_ADDRESS_REQUIRED_ERROR = "Email address is a required field"
export const CONFIRMATION_EMAIL_FROM_ADDRESS_DOMAIN_REQUIRED_ERROR = "Domain is a required field"
export const CONFIRMATION_EMAIL_REPLY_TO_NAME_REQUIRED_ERROR = "Reply to is a required field"
export const CONFIRMATION_EMAIL_REPLY_TO_ADDRESS_REQUIRED_ERROR = "Email address is a required field"
export const PAGE_HEADER_IMAGE_REQUIRED_ERROR = "Uploading an image is required when using the image page header type"
export const LINK_TO_VIDEO_REQUIRED_ERROR = "Link to video is a required field"
export const LINK_TO_VIDEO_INVALID_ERROR = "Link to video must be a valid link to a YouTube or Vimeo video"
export const PLACEHOLDERS_NOT_VALID_ERROR = "The following are invalid placeholders: "
export const CUSTOM_URL_PATH_SLASH_VALIDATION_ERROR = "Custom URL path must not contain a /"
export const BACKGROUND_COLOR_ERROR = "Background color must be a valid hex color"
export const BACKGROUND_IMAGE_ERROR = "Background image is required"
export const PLACEHOLDER_CANNOT_BE_USED_ERROR = "Placeholders cannot be used in Social Sharing"
export const TARGETED_OFFICIALS_DEFAULT_SELECTION_ERROR = "No officials were selected"
export const X_HANDLE_REQUIRED_ERROR = "X handle is a required field"
export const X_HANDLE_INVALID_ERROR = "The provided X handle is not valid"
export const GENERIC_LAYOUT_DETAILS = {
    description: "Select the appearance for your campaign.",
    name: "Layout",
    title: "Campaign Layout",
}
export const GENERIC_BASICS_DETAILS = {
    description: "Add campaign details.",
    name: "Basics",
    title: "Campaign Basics",
}
export const GENERIC_POST_ACTION_DETAILS = {
    description:
        "Determine the follow-up destination for advocates post-action, including thank you messages, emails, and social media details.",
    name: "Post Action",
    title: "Post Advocate Action",
}
export const GENERIC_FINALIZE_DETAILS = {
    description: "Stay informed on all campaign updates in Quorum.",
    name: "Finalize",
    title: "Finalize",
}
